"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserIdService = exports.userIdService = void 0;
var tslib_1 = require("tslib");
var models_1 = require("../../auth-suite-sdk-setup/models");
var access_1 = require("../access");
var error_response_1 = require("../error-response");
var models_2 = require("../providers/models");
var models_3 = require("./models");
var getUserId = function (request) {
    var requestData = assignDefaultValueToGetUserIdRequest(request);
    return filterProviderCodeAndUserId(requestData).then(function (response) { return response.providerUserId; });
};
var getProviderCodeAndUserId = function (request) {
    var requestData = assignDefaultValueToGetUserIdRequest(request);
    return filterProviderCodeAndUserId(requestData);
};
var filterProviderCodeAndUserId = function (request) {
    return access_1.accessService
        .checkAccessStatus(request)
        .then(function (response) { return getUserDetailsFromAccessMethod(response.accessMethodsInUse); });
};
var filterContentAccessMethods = function (contentAccessMethods) {
    return contentAccessMethods.filter(function (accessMethod) {
        return accessMethod.providerCode === models_3.AccessMethodId.APE && accessMethod.type === models_1.ContentAccessMethodType.Social;
    });
};
var getUserDetailsFromAccessMethod = function (contentAccessMethods) {
    var userDetails = filterContentAccessMethods(contentAccessMethods)
        .map(mapUserDetailsFromAccessMethod)
        .shift();
    return userDetails
        ? Promise.resolve(userDetails)
        : Promise.reject(error_response_1.authSuiteErrorFactory.createError(error_response_1.MethodErrorResponse.GET_USER_DETAILS_FROM_ACCESS_METHOD));
};
var mapUserDetailsFromAccessMethod = function (accessMethod) {
    return {
        providerCode: accessMethod.providerCode,
        providerUserId: accessMethod.providerUserId,
    };
};
var assignDefaultValueToGetUserIdRequest = function (request) {
    return tslib_1.__assign({ logoSchema: models_2.LogoSchema.Color }, request);
};
exports.userIdService = {
    getProviderCodeAndUserId: getProviderCodeAndUserId,
    getUserId: getUserId,
};
var UserIdService = /** @class */ (function () {
    function UserIdService() {
        return exports.userIdService;
    }
    return UserIdService;
}());
exports.UserIdService = UserIdService;
